import React from 'react';
import PropTypes from 'prop-types';

import { StyledCard, StyledCardContent, StyledCardMedia, StyledNewsCardHeader } from './style';

export const NewsCard = ({
    header,
    src,
    $imgTitle,
    $imgwidth,
    $imgMargin,
    $imgMaxWidth,
    children,
    ...rest
}) => {
    return (
        <StyledCard {...rest} $borderRadius="24px">
            {header && <StyledNewsCardHeader title={header} />}
            {src && (
                <StyledCardMedia
                    component="img"
                    image={src}
                    title={$imgTitle || 'CardMedia'}
                    $imgwidth={$imgwidth}
                    $imgMargin={$imgMargin}
                    $imgMaxWidth={$imgMaxWidth}
                />
            )}
            <StyledCardContent>{children}</StyledCardContent>
        </StyledCard>
    );
};

NewsCard.propTypes = {
    header: PropTypes.string,
    src: PropTypes.string,
    $imgTitle: PropTypes.string,
    $imgwidth: PropTypes.string,
    $imgMargin: PropTypes.string,
    $imgMaxWidth: PropTypes.string,
    children: PropTypes.any,
};
